<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Shop
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Shop Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Shop Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3 v-if="user.roleName === 'ADMIN' || user.roleName === 'BRANCH_ADMIN'">
              <v-select
                :items="warehouseList"
                label="Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="shopList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.code }}</td>
                    <td>{{ props.item.warehouseName }}</td>
                    <td>{{ props.item.address }}</td>
                    <td>{{ props.item.township }}</td>
                    <td>{{ props.item.city }}</td>
                    <td>{{ props.item.phoneNo }}</td>
                    <td>
                      {{
                        props.item.updatedDateInMilliSeconds
                          | format-ms-date-time
                      }}
                    </td>
                    <td>{{ props.item.updatedBy }}</td>
                    <td>
                      <v-btn
                        flat
                        icon
                        color="blue lighten-2"
                        @click="onEdit(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { shopService } from "../../services/shop-service";
import { warehouseService } from "../../services/warehouse-service";
export default {
  name: "ShopList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true,
      },
      {
        text: "Shop",
        disabled: true,
      },
    ],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", value: "code" },
      { text: "Warehouse", align: "left", value: "warehouseName" },
      { text: "Address", value: "address" },
      { text: "Township", value: "township" },
      { text: "City", value: "city" },
      { text: "Phone No", value: "phoneNo" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Action", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0,
    },
    shopList: [],
    warehouseList: [],
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      warehouseId: "",
      shopId: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getShopList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    if (this.user.roleName == "ADMIN" || this.user.roleName == "BRANCH_ADMIN") {
      this.getWarehouseList();
    }
    if (this.user.roleName == "SALE_MANAGER") {
      this.queryParams.shopId = this.user.shopId;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "shops", query: this.queryParams });
      this.getShopList();
    },
    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getShopList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      shopService
        .getShopList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.shopList = res.data.shopList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      //go to detail page
      this.$router.push("/shop/new");
    },
    onEdit(shop) {
      //go to detail page
      this.$router.push("/shop/" + shop.id);
    },
  },
};
</script>
